import flatpickrCss from 'flatpickr/dist/flatpickr.min.css?inline'
import Minze from 'minze'
import * as Elements from './components'
import * as constants from './constants'
import { cssVariables } from './constants'
import * as Extras from './extras'
// import { AdditionalTypes } from './modules/additionalTypes'
import './modules/locale/general'
import { ConsoleError } from './modules/logging'
import MainModule from './modules/main'
import { initAlgoliaInsights } from './utils/algolia/insights'
import { initSentry } from './utils/debug/sentry'
import { getEnvironment } from './utils/environment'
import { getContentTypeFromUrl, isEventPageType } from './utils/gtm/utilities'
import { initJiraIssueCollector } from './utils/jira/issue-collector'

declare global {
  interface Window {
    LVC_MAIN_MODULE: MainModule
    LVC_WEBCOMPONENTS_CONSTANTS: any
    LVC_SEARCH_CONFIGS: any
    dataLayer: any[]
  }
}

// Ensure dataLayer exists early for GTM/analytics consumers
try {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
} catch (err) {
  console.error(err)
}

let styleElement = document.createElement('style')
styleElement.innerHTML = flatpickrCss + cssVariables
document.head.appendChild(styleElement)

// Initialize Sentry Error Tracking
try {
  initSentry()
} catch (err) {
  console.error(err)
}

// Initialize Algolia Insights
document.addEventListener('DOMContentLoaded', () => {
  try {
    if (getEnvironment() == 'production' || getEnvironment() == 'unknown') {
      initAlgoliaInsights()
    }
  } catch (err) {
    console.error(err)
  }
})

// Initialize JIRA Issue Collector
try {
  document.addEventListener('DOMContentLoaded', initJiraIssueCollector)
} catch (err) {
  console.error(err)
}

try {
  document.addEventListener('DOMContentLoaded', () => {
    // Cache the current page content type for performance
    const currentPageType = getContentTypeFromUrl(window.location.pathname)

    document.addEventListener(
      'click',
      event => {
        if (event.button !== 0 || event.defaultPrevented) return

        const target = event.target as HTMLElement | null
        if (!target) return

        const link = target.closest('a[target="_blank"]') as HTMLAnchorElement | null

        if (link) {
          // Skip Ticket Button links
          if (link.getAttribute('data-gtm-trigger-id') === 'ticketButton') {
            return
          }

          // Skip Google Maps links (M'y rendre) - no analytics tracking
          if (link.href.includes('https://www.google.com/maps/search')) {
            return
          }

          // Handle internal lavitrine.com links
          if (link.href.includes('lavitrine.com')) {
            if (isEventPageType(link.href)) {
              // Track internal event page clicks separately
              return MainModule.getInstance()
                .analyticsTrack('vers_representation_deuxieme_niveau', {
                  link_url: link.href,
                  link_text: link.innerText,
                  emplacement: currentPageType,
                  emplacement_url: window.location.href,
                })
                .catch(console.error)
            }
            // Skip other internal links (no tracking)
            return
          }

          // Track all external links
          MainModule.getInstance()
            .analyticsTrack('cta_lien_externe', {
              emplacement: window.location.href,
              destination: link.href,
            })
            .catch(console.error) // Avoid blocking the click
        }
      },
      { passive: true }
    )
  })
} catch (err) {
  console.error(err)
}

// TESTING IF NOT REQUIRED

// setTimeout(() => {
//   AdditionalTypes.getInstance()
// }, 0)

window.LVC_SEARCH_CONFIGS = window.LVC_SEARCH_CONFIGS || constants?.config?.searchConfigs || {}
window.LVC_WEBCOMPONENTS_CONSTANTS = window.LVC_WEBCOMPONENTS_CONSTANTS || constants
//window.LVC_MAIN_MODULE = window.LVC_MAIN_MODULE || MainModule.getInstance();

Object.defineProperty(window, 'LVC_MAIN_MODULE', {
  get() {
    ConsoleError(
      true,
      "Please STOP using window.LVC_MAIN_MODULE, use instead MainModule.getInstance(), it's deprecated and will be removed in future versions."
    )
    return MainModule.getInstance()
  },
})

// Store original console.warn to restore later
const originalWarn = console.warn

// Override console.warn to filter ALL Minze property collision warnings
console.warn = function (...args) {
  const message = args.join(' ')
  // Silence all Minze property collision warnings (both "already exists" and "already exists in this component")
  if (
    message.includes('[Minze warn] A property with the name') &&
    (message.includes('already exists') || message.includes('already exists in this component'))
  ) {
    return // Silently ignore these warnings
  }
  // Allow all other warnings through
  originalWarn.apply(console, args)
}

// Define and Inject all components
Minze.defineAll(Elements)
Minze.defineAll(Extras)

// Ensure MainModule is instantiated so geolocation analytics schedules on each load
try {
  document.addEventListener('DOMContentLoaded', () => {
    MainModule.getInstance()
  })
} catch (err) {
  console.error(err)
}
